var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.4942861 5.0828934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.987854 4.88174V3.0758706h-.60183888V4.88174m-1.51129996-.90875554H.46100966L1.6678624.232129zM1.96878184 4.88174v-.90875554h-.60183887V4.88174",
    fill: "none",
    stroke: "#918f90",
    strokeWidth: 0.26458499999999996,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.699141.13229c-.84455 0-1.529644.72143-1.529644 1.61184 0 .88971.685094 1.61114 1.529644 1.61114.845255 0 1.529997-.72143 1.529997-1.61114 0-.89041-.684742-1.61184-1.529997-1.61184",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.699141.13229c-.84454998 0-1.52964441.72143054-1.52964441 1.61184163 0 .88970554.68509443 1.61113608 1.52964441 1.61113608.84525554 0 1.52999719-.72143054 1.52999719-1.61113608C6.22913819.85372054 5.54439654.13229 4.699141.13229zM.132292 4.9506h6.22970264",
    fill: "none",
    stroke: "#918f90",
    strokeWidth: 0.26458499999999996,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrees);
export default __webpack_public_path__ + "static/media/trees.370de625.svg";
export { ForwardRef as ReactComponent };